// Valmistelu › Promptit (#705) — the `instancePrompts` namespace: one Kuutio's
// own versions of the AI prompts, beside the global ones in Ylläpito › Promptit.

export const instancePromptsFi = {
  scopeTitle: "Tämän Kuution promptit: {{title}}.",
  scopeLead: "Oma versio korvaa globaalin promptin vain tässä Kuutiossa. Muut Kuutiot käyttävät globaalia promptia, jota muokataan kohdassa Ylläpito › Promptit.",
  selectInstance: "Valitse ensin Kuutio.",
  failed: "Epäonnistui: {{error}}",
  close: "Sulje",
  onlyOverridden: "Vain omat versiot ({{count}})",
  allPrompts: "Kaikki promptit",
  editingOverride: "Muokkaat vain tämän Kuution omaa versiota.",
  readOnlyGlobal: "Tämä Kuutio käyttää globaalia promptia. Tee oma versio, niin voit muokata sitä.",
  panel: {
    title: "Tämän Kuution versio",
    statusGlobal: "Globaali prompt",
    statusGlobalLead: "Kuutio käyttää samaa promptia kuin muut Kuutiot (v{{version}}).",
    statusOverride: "Oma versio",
    basedOn: "Tehty globaalista versiosta v{{base}}.",
    drift: "Globaali prompt on muuttunut sen jälkeen: nyt v{{current}}.",
    updated: "Muokattu {{date}}.",
    noHistory: "Omalla versiolla ei ole versiohistoriaa: tallennus korvaa sen.",
    delay: "Muutos tulee tekoälyn käyttöön minuutin kuluessa.",
    create: "Tee oma versio",
    createLead: "Kopioi globaalin promptin tälle Kuutiolle muokattavaksi.",
    showDiff: "Näytä ero globaaliin",
    hideDiff: "Piilota ero",
    noDiff: "Sama kuin globaali prompt.",
    remove: "Poista oma versio",
    removeConfirm: "Poistetaanko tämän Kuution oma versio? Kuutio käyttää sen jälkeen globaalia promptia, ja omat muutokset menetetään.",
    removeLabel: "Poista",
    fields: {
      description: "Kuvaus",
      qualitative: "Sisältöprompt",
      technical: "Tekninen prompt",
      user: "Tehtäväprompt",
      model: "Malli",
      maxTokens: "Max tokens",
    },
  },
};

export const instancePromptsEn = {
  scopeTitle: "This Kuutio's prompts: {{title}}.",
  scopeLead: "An own version replaces the global prompt in this Kuutio only. Other Kuutios use the global prompt, which is edited under Ylläpito › Promptit.",
  selectInstance: "Select a Kuutio first.",
  failed: "Failed: {{error}}",
  close: "Close",
  onlyOverridden: "Own versions only ({{count}})",
  allPrompts: "All prompts",
  editingOverride: "You are editing this Kuutio's own version only.",
  readOnlyGlobal: "This Kuutio uses the global prompt. Make an own version to edit it.",
  panel: {
    title: "This Kuutio's version",
    statusGlobal: "Global prompt",
    statusGlobalLead: "The Kuutio uses the same prompt as other Kuutios (v{{version}}).",
    statusOverride: "Own version",
    basedOn: "Made from global version v{{base}}.",
    drift: "The global prompt has changed since: now v{{current}}.",
    updated: "Edited {{date}}.",
    noHistory: "An own version has no version history: saving replaces it.",
    delay: "The AI uses the change within a minute.",
    create: "Make an own version",
    createLead: "Copies the global prompt to this Kuutio for editing.",
    showDiff: "Show difference from global",
    hideDiff: "Hide difference",
    noDiff: "Same as the global prompt.",
    remove: "Delete own version",
    removeConfirm: "Delete this Kuutio's own version? The Kuutio then uses the global prompt, and its own changes are lost.",
    removeLabel: "Delete",
    fields: {
      description: "Description",
      qualitative: "Content prompt",
      technical: "Technical prompt",
      user: "Task prompt",
      model: "Model",
      maxTokens: "Max tokens",
    },
  },
};

export const instancePromptsSv = {
  scopeTitle: "Den här Kuutions promptar: {{title}}.",
  scopeLead: "En egen version ersätter den globala prompten bara i den här Kuution. Andra Kuutior använder den globala prompten, som redigeras under Ylläpito › Promptit.",
  selectInstance: "Välj först en Kuutio.",
  failed: "Misslyckades: {{error}}",
  close: "Stäng",
  onlyOverridden: "Bara egna versioner ({{count}})",
  allPrompts: "Alla promptar",
  editingOverride: "Du redigerar bara den här Kuutions egen version.",
  readOnlyGlobal: "Den här Kuution använder den globala prompten. Gör en egen version för att redigera den.",
  panel: {
    title: "Den här Kuutions version",
    statusGlobal: "Global prompt",
    statusGlobalLead: "Kuution använder samma prompt som andra Kuutior (v{{version}}).",
    statusOverride: "Egen version",
    basedOn: "Gjord av den globala versionen v{{base}}.",
    drift: "Den globala prompten har ändrats sedan dess: nu v{{current}}.",
    updated: "Redigerad {{date}}.",
    noHistory: "En egen version har ingen versionshistorik: att spara ersätter den.",
    delay: "AI:n använder ändringen inom en minut.",
    create: "Gör en egen version",
    createLead: "Kopierar den globala prompten till den här Kuution för redigering.",
    showDiff: "Visa skillnaden mot den globala",
    hideDiff: "Dölj skillnaden",
    noDiff: "Samma som den globala prompten.",
    remove: "Ta bort egen version",
    removeConfirm: "Ta bort den här Kuutions egen version? Kuution använder sedan den globala prompten, och de egna ändringarna går förlorade.",
    removeLabel: "Ta bort",
    fields: {
      description: "Beskrivning",
      qualitative: "Innehållsprompt",
      technical: "Teknisk prompt",
      user: "Uppgiftsprompt",
      model: "Modell",
      maxTokens: "Max tokens",
    },
  },
};
